import { render, staticRenderFns } from "./RegisterMedicAdmin.vue?vue&type=template&id=4b2757ce&scoped=true"
import script from "./RegisterMedicAdmin.vue?vue&type=script&lang=js"
export * from "./RegisterMedicAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2757ce",
  null
  
)

export default component.exports